import { usePaldockTranslation } from "hooks/usePaldockTranslation.tsx";
import { UserRequestStatus } from "types/enums";

export const useRequestStatusSelectOptions = () => {
    const { t } = usePaldockTranslation("forms.general-options.status");

    const options = [
        { label: t("pending"), value: UserRequestStatus.Pending },
        { label: t("accepted"), value: UserRequestStatus.Accepted },
        { label: t("rejected"), value: UserRequestStatus.Rejected },
    ];

    return { options, loading: false, error: null };
};
